<!-- <dashboardnav> -->
    <cradua-incident-risk-area
    [incidentRiskAreas]="incidentRiskAreas$ | async"
    [eventTypes]="eventTypes$ | async"
    (incidentRiskArea)="onSubmitIncidentRiskArea($event)"
    (deleteIncidentRiskAreaEvent)="onDeleteIncidentRiskArea($event)"    
    *ngIf="
    !(isLoadingIncidentRiskArea$ | async ) &&
    !(isLoadingEventType$ | async )
    "
    >
  </cradua-incident-risk-area>

    <mrsoftapps-epims-reference-spinner 
    *ngIf="
  (isLoadingIncidentRiskArea$ | async ) ||
  (isLoadingEventType$ | async )
  "
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  <!-- </dashboardnav> -->
